import axios from "axios";

class EstacionamientoService {
  wsUsuarioUrl() {
    return "https://ws-usuario.cveo5ltgpic08.us-east-1.cs.amazonlightsail.com";
  }
  
  apiURLTest() {
    let API_URL = process.env.REACT_APP_ESTACIONAMIENTO_ENDPOINT
  ? process.env.REACT_APP_ESTACIONAMIENTO_ENDPOINT
  : `https://core-test.mimuni.app/mobile`;

  let baseURL = "";
if (process.env.NODE_ENV === "development") {
  baseURL = `${API_URL}`;
} else baseURL = process.env.REACT_APP_ESTACIONAMIENTO_ENDPOINT;
  return baseURL
}
    

  apiURLProd() {
        let API_URL = process.env.REACT_APP_ESTACIONAMIENTO_ENDPOINT
      ? process.env.REACT_APP_ESTACIONAMIENTO_ENDPOINT
      : `https://core-pilar.mimuni.app/mobile`;
    
      let baseURL = "";
    if (process.env.NODE_ENV === "development") {
      baseURL = `${API_URL}`;
    } else baseURL = process.env.REACT_APP_ESTACIONAMIENTO_ENDPOINT;
      return baseURL
    }

    apiURL() {
      //return this.apiURLTest();
      return this.apiURLProd();
    }

    shortUrlTest() {
      return "https://core-test.mimuni.app";
    }
    shortUrlProd() {
      return "https://core-pilar.mimuni.app";
    }

    shortUrl() {
      //return this.shortUrlTest();
      return this.shortUrlProd();
    }

    tokenServicioProd() {
      return "a586da27ac5bd5a6de97a2c3f6198e7568e47ccdaf53a7594cabecd07f329f0f";
    }

    tokenServicioTest() {
      return "48D7F6346A1FA9950C208468C62E5260B6DFE04D873E2D1081D42B763DC746CB";
    }

    tokenServicio() {
      //return this.tokenServicioTest();
      return this.tokenServicioProd();
    }

    login(celular, password) {
        return axios.post(this.apiURL()+"/login?celular="+celular+"&version=1&password="+password+"&agente=8&tokenservicio="+this.tokenServicio())
    }


    buscarLugaresLibres(latitud, longitud){
        return axios.post( this.apiURL() + "/buscarSensoresPorCoordenadas?version=1&agente=8&tokenservicio="+this.tokenServicio()+"&latitud="+latitud+"&longitud="+longitud);

    }

    cambiarEstadoSensorOcupado(sensorSerial,ocupado){
        return axios.post(this.shortUrl()+"/webhooksensors/updatesensorstatus",{ serial: sensorSerial, status:ocupado, date: new Date().toISOString()})
    }

    iniciarEstacionamiento(celular, patente, token, sensorSerial){
      return axios.post(this.apiURL()+"/iniciarEstacionamiento?celular="+celular+"&agente=8&version=1&codigoMunicipio=1&tokenservicio="+this.tokenServicio()+"&matricula="+patente+"&token="+token+"&internalDeviceId="+sensorSerial)
    }

    finalizarEstacionamiento(celular, patente, token){
      return axios.post(this.apiURL()+"/finalizarEstacionamiento?celular="+celular+"&agente=8&version=1&codigoMunicipio=1&tokenservicio="+this.tokenServicio()+"&matricula="+patente+"&token="+token);
    }

    cargarPatentes(celular, token){
      return axios.post(this.apiURL()+"/getPatentes?celular="+celular+"&agente=8&version=1&codigoMunicipio=1&tokenservicio="+this.tokenServicio()+"&token="+token);
    }

    agregarPatente(celular, token, patente){
      return axios.post(this.apiURL()+"/addPatente?celular="+celular+"&agente=8&version=1&codigoMunicipio=1&tokenservicio="+this.tokenServicio()+"&token="+token+"&patente="+patente);
    }

    obtenerDatosCiudadano(hashLogin) {
      return axios.get("https://api.ciudadanos360.com/login/GetDatosCiudadano/"+hashLogin)
  }
    
   consultarEstado(celular, token) {
      return axios.post(this.apiURL()+"/consultarEstado?celular="+celular+"&agente=8&version=1&tokenservicio="+this.tokenServicio()+"&token="+token)
   }

   olvideClave(celular){
    return axios.post(this.apiURL()+"/olvideClave?celular="+celular+"&agente=8&version=1&tokenservicio="+this.tokenServicio())
   }

   registro(celular, fechaNacimiento, documento, mail) {
    return axios.post(this.apiURL()+"/registrarUsuario?celular="+celular+"&version=1&agente=8&tokenservicio="+this.tokenServicio()+"&birthDate="+fechaNacimiento+"&documentNumber="+documento+"&idCarrier=1&email="+mail)
   }

   cambioClave(celular, viejaClave, nuevaClave, token) {
    return axios.post(this.apiURL()+"/changePassword?celular="+celular+"&version=1&lastPassword="+viejaClave+"&agente=8&tokenservicio="+this.tokenServicio()+"&newPassword="+nuevaClave+"&token="+token);
   }

   recuperoPrimerCelular(hashLogin, dni) {
    return axios.get(this.wsUsuarioUrl()+"/users/parking-phone?document="+dni+"&hashLogin="+hashLogin)
   }

   inicioCargaCredito(celular, token, monto){
    return axios.post(this.apiURL()+"/iniciarCargaCreditoEPagos?celular="+celular+"&version=1&token="+token+"&agente=8&tokenservicio="+this.tokenServicio()+"&monto="+monto+"00");
   }

   obtenerSensorPorCodigo(codigo) {
    return axios.post("https://core-pilar.mimuni.app/mobile/buscarSensorPorCodigo?version=1&agente=8&tokenservicio="+this.tokenServicio()+"&sensorCode="+codigo)
   }

   estadoUltimaCargaEPagos(celular, token) {
    return axios.post(this.apiURL()+"/consultarUltimaCargaCreditoEPagos?celular="+celular+"&version=1&token="+token+"&agente=8&tokenservicio="+this.tokenServicio());
   }

   cancelaUltimaCargaEPagos(celular, token, monto, transaccionId) {
    return axios.post(this.apiURL()+"/cancelarOperacionPendienteEPagos?celular="+celular+"&version=1&token="+token+"&agente=8&tokenservicio="+this.tokenServicio()+"&monto="+monto+"&transactionId="+transaccionId);
   }

   editarPerfilUsuario(datos) {
    return axios.post(this.wsUsuarioUrl()+"/users/update-user",datos)
   }

   borrarPerfilUsuario(datos) {
    return axios.post(this.wsUsuarioUrl()+"/users/remove-user",datos)
   }


    
}
export default new EstacionamientoService()